export class EnrollmentError {
  code?: number | null;
  message?: string | null;
}
